import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { finalize, mergeMap, take} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';
import { UserService } from '../../dataServices/userService';
import { Subscription } from 'rxjs';

@Component({
    selector: 'home',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, OnDestroy {
    public email: string = '';
    public password: string = '';
    public user: User | null = null;
    private userSubscribe: Subscription | null = null;

    public constructor(private router: Router,
                       private progressBar: NgProgress,
                       private userService: UserService,
                       private appState: AppState,
                       private toastrService: ToastrService
                       ) {}

    public ngOnDestroy() {
        if (this.userSubscribe) {
            this.userSubscribe.unsubscribe();
        }        
    }

    public ngOnInit() {
        this.progressBar.ref().start();
        this.userSubscribe = this.appState.user
        .pipe(
            mergeMap((user) => {
                this.user = user;
                return this.userService.isEnrolled()
            }),
            mergeMap((enrolled) => {
                if (this.user) {
                    this.user.status = enrolled ? 'active': 'provisioning';
                    this.user.expires = Date.now() + 86400000;
                }
               return this.userService.getUserVerificationInfo();
            }),
            finalize(() => {
                this.progressBar.ref().complete();
            })
        ).subscribe(
            (data) => {
                this.ngOnDestroy();
                if (this.user) {
                    this.user.verificationInfo = data;
                    this.appState.updateUser(this.user);
                    switch (this.user.status) {
                        case 'active':
                            this.router.navigate(['/coverage']);
                            break;
                        case 'provisioning':
                            this.router.navigate(['/verification']);
                            break;
                        default:
                            this.toastrService.error('User is inactive');
                    }
                }
            }, 
            (error) => {
                if (this.user) {
                    this.appState.updateUser(this.user);
                }
                this.router.navigate(['/error']);
            }
        );
    }
}